import React from 'react';
import { Flex, Box } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import ClearFilters from 'components/Filters/Search/ClearFilters';
import { mediaQuery } from 'lib/styledSystem';
import Header from 'components/MapSearchPage/Header';
import { HEADER_HEIGHT } from 'components/MapSearchPage/primitives';
import PriceFilterItem from './items/PriceFilterItem';
import PaymentPolicyFilterItem from './items/PaymentPolicyFilterItem';
import FacilityFilterItem from './items/FacilityFilterItem';
import PropertyTypeFilterItem from './items/PropertyTypeFilterItem';
import StarRatingFilterItem from './items/StarRatingFilterItem';
import TripadvisorRatingFilterItem from './items/TripadvisorRatingFilterItem';
import SearchSummary from './SearchSummary';

const MapFiltersBarWrapper = styled(Flex)`
  width: 100%;
  justify-content: center;
  border-bottom: ${themeGet('borders.1')} ${themeGet('colors.greys.alto')};
  background-color: ${themeGet('colors.white')};
  height: ${HEADER_HEIGHT};

  ${mediaQuery.minWidth.md} {
    justify-content: flex-end;
  }
`;

const MapFiltersBar = React.memo(() => {
  return (
    <Flex width="100%" top="0">
      <Header />
      <MapFiltersBarWrapper>
        <SearchSummary />
        <Box display={['none', 'none', 'flex']}>
          <PriceFilterItem />
          <PaymentPolicyFilterItem />
          <FacilityFilterItem />
          <PropertyTypeFilterItem />
          <StarRatingFilterItem />
          <TripadvisorRatingFilterItem />
          <ClearFilters hideTitle textDecoration="none" />
        </Box>
      </MapFiltersBarWrapper>
    </Flex>
  );
});

MapFiltersBar.displayName = 'MapFiltersBar';

export default MapFiltersBar;
